import React, { useState } from "react";
import axios from "axios";
import { Formik, Form, Field } from "formik";
import { Button, Typography, Input, Spin, Image, message } from "antd";
import { API_BASE_URL } from "../config/apiConfig";
import { useTranslation } from "react-i18next";
import HomeButton from "../components/HomeButton";

const { Title } = Typography;

const KazClip: React.FC = () => {
  const [images, setImages] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (values: { inputText: string }) => {
    setLoading(true);
    setImages([]);

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/zhadiger/api/kaz-clip`,
        { inputText: values.inputText },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      const base64Images: string[] = response.data;

      // console.log("Received base64 strings:", base64Images);

      const validImages = Array.isArray(base64Images)
        ? base64Images
            .filter((img) => typeof img === "string" && img.trim().length > 0)
            .map((img) => `data:image/jpeg;base64,${img}`)
        : [];

      setImages(validImages);

      if (validImages.length > 0) {
        message.success("Images generated successfully!");
      } else {
        message.warning("No valid images were returned.");
      }
    } catch (error) {
      message.error("Failed to generate images.");
      console.error("Error fetching images:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-4 ml-4 pt-4 ">
        <HomeButton />
      </div>
      <div className="max-w-[70%] mx-auto mt-10 p-6 bg-white border border-gray-200 rounded-lg shadow-md">
        <Title level={2} className="text-center font-bold text-gray-700">
          KazClip
        </Title>

        <Formik initialValues={{ inputText: "" }} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form className="mt-6">
              <div className="mb-4">
                <Field
                  name="inputText"
                  as={Input.TextArea}
                  placeholder={t("enter_your_text")}
                  rows={4}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="flex justify-center">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading || isSubmitting}
                  className="w-80%"
                >
                  {loading ? "Generating..." : t("generate_images")}
                </Button>
              </div>
            </Form>
          )}
        </Formik>

        <div className="mt-6">
          {loading ? (
            <div className="text-center">
              <Spin size="large" />
            </div>
          ) : images.length > 0 ? (
            <div>
              <Title level={4} className="text-gray-600">
                {t("generated_images")}:
              </Title>
              <div className="flex flex-wrap gap-4 mt-4">
                {images.map((image, index) => (
                  <Image
                    key={index}
                    src={image}
                    alt={`Generated ${index}`}
                    width={200}
                    height={200}
                    style={{ objectFit: "cover" }}
                  />
                ))}
              </div>
            </div>
          ) : (
            <p className="text-center text-gray-500">{t("no_images")}.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default KazClip;
